<template>
  <div class="container">
    <div class="main">
      <div class="left">
        <div class="title">关于智签</div>
        <div class="text">
          北京智签科技有限公司（简称：智签科技）是真相网络科技（北京）有限公司（简称：真相科技）的子公司，专注于为金融行业提供“区块链+司法”综合服务，核心团队深耕金融、科技、司法行业多年。<br />
          参与最高人民法院《互联网时代电子诉讼规则研究》课题，自主研发了区块链电子数据存证系统、区块链签控一体化平台、区块链赋强公证平台、金融纠纷多元化解平台，多个服务特点入选中国人民银行金融科技蓝皮书、中国区块链技术和应用发展研究报告（2018）。
        </div>
      </div>
      <div class="right">
        <div
          class="right_box"
          @click="
            $router.push('/corp');
            $emit('close');
          "
        >
          <div class="title">公司简介</div>
        </div>
        <div
          class="right_box"
          @click="
            $router.push('/news');
            $emit('close');
          "
        >
          <div class="title">新闻速递</div>
        </div>
        <div
          class="right_box"
          @click="
            $router.push('/partners');
            $emit('close');
          "
        >
          <div class="title">合作伙伴</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  created() {},

  methods: {},
};
</script>

<style scoped lang="scss">
.container {
  background-color: #f4f5f7;
  height: 540px;
  .main {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    .left {
      width: 270px;
      position: relative;
      z-index: 99999;
      height: 100%;

      .title {
        margin: 40px 0 24px;
        color: #000000;
        position: relative;
        z-index: 99999;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
      .text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #808080;
        position: relative;
        z-index: 99999;
        line-height: 20px;
        width: 236px;
        height: 140px;
        margin-right: 30px;
      }
    }
    .left:before {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 50vw;
      z-index: 0;
      height: 100%;
      background: #fff url(~@/assets/image/header/left.png) right bottom
        no-repeat;
      background-size: 650px auto;
    }
    .right {
      // background-color: #fff;
      width: 930px;
      height: 100%;
      padding: 46px 0 50px 40px;
      position: relative;
      .right_box {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        display: flex;
        margin-bottom: 69px;
        position: relative;
        align-items: center;
        cursor: pointer;
        .title {
          width: 140px;
          text-align: center;
          font-size: 14px;
          color: #37393b;
          margin-right: 10px;
        }
        .context {
          flex: 1;
          font-size: 12px;
          color: #656565;
          .info {
            margin-bottom: 13px;
          }
          .tag {
            display: flex;
            justify-content: space-between;
            label {
              color: #37393b;
              margin-right: 6px;
            }
            span {
              display: inline-block;
              height: 22px;
              border: 1px solid #c6c6c6;
              padding: 2px 18px;
              margin-right: 28px;
              color: #c6c6c6;
            }
            .icon {
              color: $main_color;
              cursor: pointer;
            }
          }
        }
      }
      .right_box:last-child {
        margin-bottom: 0;
      }
    }
    .right:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 70vw;
      height: 100%;
      background: #fff url(~@/assets/image/header/right.png) left bottom
        no-repeat;
      background-size: 100% 540px;
    }
  }
}
</style>
